import request from '@/router/axios'

// 汽车管理 - 客户运输画像
const base = '/api/produce/data-statistics/customer-transport-portrait'

/**
 * 获取单个客户的运输画像数据
 *
 * 预留接口位置，后端实现后：
 * - 支持按客户、时间区间、业务类型（汽车出库 businessType=2）等查询
 * - 返回结构建议与前端 portrait 对象字段一致：
 *   {
 *     customerName, creditCode, contactPerson, contactPhone,
 *     contractAmount, completedAmount,
 *     monthlyFreq, currentStock, turnoverRate, turnoverDays,
 *     commonCoal, avgStayTime, level, creditLimit, prepayBalance, levelReason,
 *     coalDetails: [], feeDetails: {}, monthlyTrend: [], coalPref: {},
 *     railIn, truckIn, warnings: []
 *   }
 */
export function getCustomerPortrait(data) {
  // 目前仅预留真实接口调用，方便后端联调时直接启用
  return request({
    url: `${base}/detail`,
    method: 'post',
    data
  })
}

